/**
 * @fileoverview GET handler for the "/engagement/campaigns/:app_group_id/campaigns_with_exceptions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsAppGroupIdCampaignsWithExceptions } from "./constants";
import type { CampaignsWithExceptionsResult } from "./types";
import { isCampaignsWithExceptionsResult } from "./validators";

export const getCampaignsWithExceptions = reactQueryFetcherAdapter(
  engagementCampaignsAppGroupIdCampaignsWithExceptions,
  (signal: AbortSignal, appGroupId: string): Promise<CampaignsWithExceptionsResult> => {
    return fetch(`/engagement/campaigns/${appGroupId}/campaigns_with_exceptions`, "GET", {}, { signal });
  },
  isCampaignsWithExceptionsResult
);
